<template>
  <div>
    <v-dialog v-model="dialog" eager persistent scrollable max-width="600">
      <v-form ref="RemarksForm" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex align-center dialog-header">
            <span>Remarks</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="white"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="remarks"
                    :rules="[formRules.required]"
                    :color="$vuetify.theme.themes.light.inputColor"
                    placeholder="Please type here..."
                    variant="outlined"
                    density="compact"
                    rows="5"
                    cols="10"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2 mr-4">
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              density="comfortable"
              variant="flat"
              :disabled="btnLoading"
              :loading="btnLoading"
              @click="save()"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
// import eventBus from "@/eventBus";
export default {
  props: {
    data: Boolean,
    action: String,
  },
  data() {
    return {
      dialog: false,
      remarks: null,
      btnLoading: false,
    };
  },
  watch: {
    data: {
      handler(data) {
        this.dialog = data;
        this.remarks = null;
      },
      immediate: true,
    },
  },
  methods: {
    async save() {
      let validate = await this.$refs.RemarksForm.validate();
      if (validate.valid) {
        this.$emit("save", this.remarks);
      }
    },

    closeD() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.tbl {
  width: 100%;
  border-collapse: collapse;
}
</style>
